// React imports.
import React, { Component } from "react";
//library imports
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// App imports.
import ReadingIndexValues from "./ReadingIndexValues";

const BenefitTargeting1 = ({ history }) => {
  // Safety check to ensure LatestYear exists
  const latestYear = history.LatestYear || {};
  const fiscalYear = latestYear.Year || '';

  let options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'column',
    },
    title: {
      text: history.SelectedIndexString + ' Index'
    },
    xAxis: {
      labels: {
        enabled: true,
      },
      categories: [],
      crosshair: true
    },
    yAxis: {
      plotLines: [{
        color: '#FF0000',
        width: 2,
        value: 100,
        dashStyle: 'ShortDash',
      }],
      min: 0,
      max: 200,
      title: {
        text: history.SelectedIndexString + ' Index'
      }
    },
    series: [
      {
        name: history.SelectedIndexString + ' Index',
        data: [],
        showInLegend: false,
      }
    ],
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      },
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
  };

  let dataArray = [];
  dataArray.push(history.LatestYearSelectedIndex);

  if (+history.LatestYearSelectedIndex > 200) {
    options.yAxis.max = +history.LatestYearSelectedIndex + 30;
  }


  options.xAxis.categories.push(history.GranteeName);
  options.series[0].data = dataArray;

  return (
    <div >
      <h2>{history.SelectedIndexString}   Index – FY{fiscalYear}</h2>
      <br />
      <p>
        In FY{fiscalYear}, {history.GranteeName}'s   {history.SelectedIndexString}  Index was:
      </p>

      <div className="container">
        <div className="row">
          <div className="col-sm-3 font-weight-bold offset-sm-3 h5  text-right">{history.GranteeName}   in FY {fiscalYear}:</div>
          <div className="col-sm-3 font-weight-bold h5  text-left">{history.LatestYearSelectedIndex}</div>
        </div>
      </div>
      <br />
      <p>
        This means that, on average, the highest burden LIHEAP households in&nbsp;{history.GranteeName}&nbsp;
        {history.LatestYearSelectedIndexPctDiffString}
      </p>
      <div className="container">
        <div className="row">
          <div className="col-sm-7">
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
          <div className="col-sm-5 takeaways">
            <ReadingIndexValues history={history} />
          </div>
        </div>
      </div>


      <br />
      <p> <span>Please click <em>Next </em>to continue.</span></p>
    </div>
  );
}
export default BenefitTargeting1;
